import { ChangeDetectionStrategy, Component, Inject, Input, NgModuleRef } from '@angular/core';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { INFO_MODAL_DATA, InfoModal } from '../../../../modals/info/info.modal';

@Component({
  selector: 'gtd-offer-description',
  templateUrl: './offer-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferDescriptionComponent {
  @Input() data: { description: string; description_preset_description: string };

  constructor(@Inject(IMODALS_SERVICE) public modalsService: IModalsService, private moduleRef: NgModuleRef<any>) {}

  public showDescriptionModal(): void {
    this.modalsService.open(
      InfoModal,
      {
        data: {
          ...INFO_MODAL_DATA.OFFER_DESCRIPTION,
          body: this.data.description_preset_description || this.data.description,
        },
      },
      this.moduleRef
    );
  }

  protected readonly length = length;
}
